var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1579_202575)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0448 1.00243H14.2356V2.20535H18.0448V1.00243ZM13.2332 0V3.20779H19.0473V0H13.2332Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2597 3.20779H7.8198C6.71254 3.20779 5.81493 4.1054 5.81493 5.21266V6.41558H26.2646V5.21266C26.2646 4.1054 25.367 3.20779 24.2597 3.20779ZM7.8198 2.20536C6.15891 2.20536 4.8125 3.55177 4.8125 5.21266V7.41801H27.267V5.21266C27.267 3.55177 25.9206 2.20536 24.2597 2.20536H7.8198Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8274 16.6404H21.2527C24.0208 16.6404 26.2648 14.3964 26.2648 11.6282V9.62334L5.81519 9.62335L5.81519 11.6282C5.81519 14.3964 8.05922 16.6404 10.8274 16.6404ZM21.2527 17.6428C24.5744 17.6428 27.2673 14.95 27.2673 11.6282V8.62091L4.81276 8.62091L4.81276 11.6282C4.81276 14.95 7.50559 17.6428 10.8274 17.6428H21.2527Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2598 28.4691C25.3671 28.4691 26.2647 27.5715 26.2647 26.4643C26.2647 25.357 25.3671 24.4594 24.2598 24.4594C23.1526 24.4594 22.255 25.357 22.255 26.4643C22.255 27.5715 23.1526 28.4691 24.2598 28.4691ZM24.2598 29.4716C25.9207 29.4716 27.2671 28.1251 27.2671 26.4643C27.2671 24.8034 25.9207 23.457 24.2598 23.457C22.5989 23.457 21.2525 24.8034 21.2525 26.4643C21.2525 28.1251 22.5989 29.4716 24.2598 29.4716Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2598 31.0754C26.8065 31.0754 28.871 29.0109 28.871 26.4642C28.871 23.9175 26.8065 21.853 24.2598 21.853C21.7131 21.853 19.6486 23.9175 19.6486 26.4642C19.6486 29.0109 21.7131 31.0754 24.2598 31.0754ZM24.2598 32.0778C27.3602 32.0778 29.8735 29.5645 29.8735 26.4642C29.8735 23.3639 27.3602 20.8506 24.2598 20.8506C21.1595 20.8506 18.6462 23.3639 18.6462 26.4642C18.6462 29.5645 21.1595 32.0778 24.2598 32.0778Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5969 21.9573L19.4918 17.2458L20.407 16.8369L22.5121 21.5483L21.5969 21.9573Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05712 31.7721L11.7734 16.8358L12.6877 17.2469L5.97137 32.1832L5.05712 31.7721Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1477 26.5645H8.22116V25.562H19.1477V26.5645Z",
    fill: "#F6931E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1579_202575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrill);
export default __webpack_public_path__ + "static/media/grill.6748b960e47a40bcece0432ce79b9071.svg";
export { ForwardRef as ReactComponent };